import styles from './ModeBar.module.css';

export type CategoryFilter = { id: string; label: string; isCustom?: boolean };

interface ModeBarProps {
  categories: CategoryFilter[];
  activeChips: string[];
  onToggleChip: (id: string) => void;
  onDeleteChip?: (id: string) => void;
}

export default function ModeBar({ categories, activeChips, onToggleChip, onDeleteChip }: ModeBarProps) {
  return (
    <div className={styles.modeBar}>
      <div className={styles.chips} role="tablist" aria-label="Content category filter">
        {categories.map(({ id, label, isCustom }) => (
          <button
            key={id}
            role="tab"
            aria-selected={activeChips.includes(id)}
            className={`${styles.chip} ${activeChips.includes(id) ? styles.chipActive : ''} ${isCustom ? styles.chipCustom : ''}`}
            onClick={() => onToggleChip(id)}
          >
            {label}
            {isCustom && onDeleteChip && (
              <span
                className={styles.chipDelete}
                role="button"
                aria-label={`Delete ${label}`}
                onClick={(e) => { e.stopPropagation(); onDeleteChip(id); }}
              >
                ×
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
